import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { LanguageProvider } from "./contexts/LanguageContext";
import { AuthProvider } from "./contexts/AuthContext";
import { Layout } from "./components/layout/Layout";
import { Toaster } from "./components/ui/sonner";
import { ScrollToTop } from "./components/ScrollToTop";

// Public Pages
import { HomePage } from "./components/pages/HomePage";
import { CragsListPage } from "./components/pages/CragsListPage";
import { CragPage } from "./components/pages/CragPage";
import { DonationsPage } from "./components/pages/DonationsPage";
import { ContactPage } from "./components/pages/ContactPage";
import { AboutPage } from "./components/pages/AboutPage";
import { EventsPage } from "./components/pages/EventsPage";
import { ProjectsPage } from "./components/pages/ProjectsPage";
import { BlogPage } from "./components/pages/BlogPage";
import { GalleryPage } from "./components/pages/GalleryPage";
import { HowToArrivePage } from "./components/pages/HowToArrivePage";
import { AccommodationPage } from "./components/pages/AccommodationPage";

// Admin Pages
import { AdminLoginPage } from "./components/pages/AdminLoginPage";
import { AdminDashboard } from "./components/pages/AdminDashboard";
import { AdminCrags } from "./components/pages/AdminCrags";
import { AdminTeam } from "./components/pages/AdminTeam";
import { AdminEvents, AdminProjects } from "./components/pages/AdminEventsProjects";
import { AdminBlog } from "./components/pages/AdminBlog";
import { AdminGallery } from "./components/pages/AdminGallery";
import { AdminAccommodations } from "./components/pages/AdminAccommodations";
import { AdminMessages } from "./components/pages/AdminMessages";
import { AdminSettings } from "./components/pages/AdminSettings";
import { AdminSEO } from "./components/pages/AdminSEO";
import { AdminUploads } from "./components/pages/AdminUploads";

function App() {
  return (
    <HelmetProvider>
      <LanguageProvider>
        <AuthProvider>
          <BrowserRouter>
            <ScrollToTop />
            <Routes>
              {/* Public Routes with Layout */}
              <Route path="/" element={<Layout><HomePage /></Layout>} />
              <Route path="/crags" element={<Layout><CragsListPage /></Layout>} />
              <Route path="/crags/:slug" element={<Layout><CragPage /></Layout>} />
              <Route path="/donations" element={<Layout><DonationsPage /></Layout>} />
              <Route path="/contact" element={<Layout><ContactPage /></Layout>} />
              <Route path="/how-to-arrive" element={<Layout><HowToArrivePage /></Layout>} />
              <Route path="/accommodation" element={<Layout><AccommodationPage /></Layout>} />
              
              {/* Team Routes */}
              <Route path="/team/about" element={<Layout><AboutPage /></Layout>} />
              <Route path="/team/events" element={<Layout><EventsPage /></Layout>} />
              <Route path="/team/projects" element={<Layout><ProjectsPage /></Layout>} />
              <Route path="/team/blog" element={<Layout><BlogPage /></Layout>} />
              <Route path="/team/blog/:slug" element={<Layout><BlogPage /></Layout>} />
              <Route path="/team/gallery" element={<Layout><GalleryPage /></Layout>} />

              {/* Admin Routes (no layout) */}
              <Route path="/admin/login" element={<AdminLoginPage />} />
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="/admin/crags" element={<AdminCrags />} />
              <Route path="/admin/team" element={<AdminTeam />} />
              <Route path="/admin/events" element={<AdminEvents />} />
              <Route path="/admin/projects" element={<AdminProjects />} />
              <Route path="/admin/blog" element={<AdminBlog />} />
              <Route path="/admin/gallery" element={<AdminGallery />} />
              <Route path="/admin/accommodations" element={<AdminAccommodations />} />
              <Route path="/admin/messages" element={<AdminMessages />} />
              <Route path="/admin/settings" element={<AdminSettings />} />
              <Route path="/admin/seo" element={<AdminSEO />} />
              <Route path="/admin/uploads" element={<AdminUploads />} />
              <Route path="/admin/*" element={<AdminDashboard />} />
            </Routes>
            <Toaster position="top-right" />
          </BrowserRouter>
        </AuthProvider>
      </LanguageProvider>
    </HelmetProvider>
  );
}

export default App;
